import type { PlanningLens } from 'pages/FarmsPage/hooks/resolvePlanningLens';
import { CalculatorId } from 'utils/calculators';

import type { InsightsTab, NutritionSaveState } from '../slices/InsightsSlice';
import { RootState } from '../Store';

export const getInsightsActiveTab = (state: RootState): InsightsTab =>
  state.insightsReducer.activeTab;

export const getPlanningLens = (state: RootState): PlanningLens | null =>
  state.insightsReducer.planningLens;

export const getNutritionSave = (state: RootState): NutritionSaveState =>
  state.insightsReducer.nutritionSave;

/** The calculator the RH panel's Calculators tool shows (OP-2585). */
export const getRightPanelActiveCalculator = (
  state: RootState
): CalculatorId =>
  state.insightsReducer.rightPanel.activeCalculator;
